// @flow
import React from 'react';
import styles from 'app/common/react/components/common/ExperimentalLegoGestalt/PogStyles';
import { Box, Icon } from 'gestalt';

const SIZE_NAME_TO_PIXEL = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 56,
};

const pogStyles = {
  alignItems: 'center',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
};

const focusedStyles = {
  boxShadow: '0 0 0 4px rgba(0, 132, 255, .5)',
  outline: 0,
};

type Props = {|
  active?: boolean,
  bgColor?: 'transparent' | 'transparentDarkGray' | 'gray' | 'lightGray' | 'white' | 'red',
  focused?: boolean,
  hovered?: boolean,
  icon: string,
  iconColor?: 'gray' | 'darkGray' | 'red' | 'blue' | 'white',
  iconSize?: number,
  size?: $Keys<typeof SIZE_NAME_TO_PIXEL>,
  title?: string,
|};

const defaultIconButtonIconColors = {
  transparent: 'gray',
  gray: 'white',
  lightGray: 'gray',
  white: 'gray',
  transparentDarkGray: 'white',
  red: 'white',
};

export default function Pog(props: Props) {
  const {
    active = false,
    bgColor = 'transparent',
    focused = false,
    hovered = false,
    icon,
    iconColor = defaultIconButtonIconColors[bgColor],
    size = 'md',
    title = '',
  } = props;

  const iconSize = props.iconSize || SIZE_NAME_TO_PIXEL[size] / 2;

  const inlineStyle = {
    height: SIZE_NAME_TO_PIXEL[size],
    width: SIZE_NAME_TO_PIXEL[size],
  };

  const styleObj = {
    ...pogStyles,
    ...styles[bgColor],
    ...(active ? styles[`${bgColor}Active`] : {}),
    ...(focused ? focusedStyles : {}),
    ...(focused ? styles[`${bgColor}Focused`] : {}),
    ...(hovered && !focused && !active ? styles[`${bgColor}Active`] : {}),
  };

  return (
    <div style={{ ...inlineStyle, ...styleObj }}>
      <Box shape="circle">
        {/*
          We're explicitly setting an empty string as a label on the Icon since we
          already have an aria-label on the button container.
          This is similar to having empty `alt` attributes:
          https://davidwalsh.name/accessibility-tip-empty-alt-attributes
        */}
        {/* $FlowFixMe */}
        <Icon accessibilityLabel="" color={iconColor} icon={icon} size={iconSize} title={title} />
      </Box>
    </div>
  );
}
